import React, { Component, useState } from 'react';
import i18next from 'i18next';
import { withTranslation } from 'react-i18next';
import HeroSection from './HeroSection/HeroSection';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";


const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 5
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 4
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 2
  }
};

const destinations = [
  { name: "Valparaiso", image: "destination-valparaiso.png" },
  { name: "Valparaiso", image: "destination-valparaiso.png" },
  { name: "Valparaiso", image: "destination-valparaiso.png" },
  { name: "Valparaiso", image: "destination-valparaiso.png" },
  { name: "Valparaiso", image: "destination-valparaiso.png" },
  { name: "Valparaiso", image: "destination-valparaiso.png" },
  { name: "Valparaiso", image: "destination-valparaiso.png" },
  { name: "Valparaiso", image: "destination-valparaiso.png" },
  { name: "Valparaiso", image: "destination-valparaiso.png" },
  { name: "Valparaiso", image: "destination-valparaiso.png" },
  { name: "Valparaiso", image: "destination-valparaiso.png" },
  { name: "Valparaiso", image: "destination-valparaiso.png" },
  { name: "Valparaiso", image: "destination-valparaiso.png" },
  { name: "Valparaiso", image: "destination-valparaiso.png" },
];

const tabs = [
  { name: 'Zona Norte' },
  { name: 'Zona Central' },
  { name: 'Zona Sur' },
]


const DestinationItem = ({ destination }) => {
  return (
    <div className="destination-item">
      <img src={'/images/' + destination.image} />
    </div>
  )
}

const TabItem = ({ item, onSelect, active }) => {
  return (
    <div className={"tab-item " + (active ? 'active bold-text white-text' : '')} onClick={onSelect}>
      {item.name}
    </div>
  )
}

const Tabs = ({ tabs, onSelect, selectedTab }) => {
  return (
    <div className="tab-container">
      {tabs.map((item, i) => (
        <TabItem item={item} key={i} onSelect={() => onSelect(i)} active={selectedTab === i} />
      ))}
    </div>
  )
}


const Destinations = props => {
  const [selectedTab, setSelectedTab] = useState(0)

  return (
    <React.Fragment>
      <div className="destinations-page">
        <HeroSection
          title="Destinos"
          description="Home / Destinos"
          heroImage="/images/destinations-banner.jpeg"
          height="40vh"
        />
        <div className="content-container">

          <div className="page-heading">
            <div className="title font15">¡Viaja por Chile!</div>
            <div className="yellow-line"></div>
          </div>

          <div className="tab-menu font10">
            <Tabs tabs={tabs} onSelect={(i) => setSelectedTab(i)} selectedTab={selectedTab} />
          </div>

          <div className="destinations-scroll">
            <Carousel
              responsive={responsive}>
              {destinations.map((val, key) => (
                <DestinationItem destination={val} key={key} />
              ))}
            </Carousel>
          </div>

        </div>


      </div>
    </React.Fragment>
  )
}

export default withTranslation('common')(Destinations);


// WEBPACK FOOTER //
// ./src/features/pages/Destinations.js